import { render } from "./EventDetailsView.vue?vue&type=template&id=1bfeca39&scoped=true"
import script from "./EventDetailsView.vue?vue&type=script&lang=js"
export * from "./EventDetailsView.vue?vue&type=script&lang=js"

import "./EventDetailsView.vue?vue&type=style&index=0&id=1bfeca39&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfeca39"]])

export default __exports__